module.exports = __webpack_public_path__ + "img/playerpause.df7ade4f.svg";